"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conflictingConfigsMessage = exports.wrongInitResultMessage = void 0;
exports.wrongInitResultMessage = `"initChart" function should resolve to an object with "sciChartSurface" property ({ sciChartSurface })`;
exports.conflictingConfigsMessage = `Only one of "initChart" or "config" props is required!`;
//# sourceMappingURL=constants.js.map